import RatingAgenciesTable from './RatingAgenciesTable';

export default RatingAgenciesTable;
